import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { PortfolioProductCharging, PortfolioBookablePeriod } from '@mews-commander/data-access';
import { ProductChargingMode } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { ConfigureProductFormStep } from '../forms/schemas/configureProductFormSchema';

export const configureProductSteps: NonEmptyArray<ConfigureProductFormStep> = [
    ConfigureProductFormStep.Details,
    ConfigureProductFormStep.Taxes,
    ConfigureProductFormStep.Pricing,
    ConfigureProductFormStep.Accounting,
    ConfigureProductFormStep.Services,
];

export const portfolioProductChargingToProductChargingModeMap: Record<PortfolioProductCharging, ProductChargingMode> = {
    [PortfolioProductCharging.Once]: ProductChargingMode.Once,
    [PortfolioProductCharging.PerPerson]: ProductChargingMode.PerPerson,
    [PortfolioProductCharging.PerPersonPerTimeUnit]: ProductChargingMode.PerPersonPerTimeUnit,
    [PortfolioProductCharging.PerTimeUnit]: ProductChargingMode.PerTimeUnit,
};

export const portfolioBookablePeriodToTextKeyMap: Record<PortfolioBookablePeriod, TextKey> = {
    [PortfolioBookablePeriod.Hour]: TextKey.Hour,
    [PortfolioBookablePeriod.Day]: TextKey.Day,
    [PortfolioBookablePeriod.Night]: TextKey.Night,
    [PortfolioBookablePeriod.Month]: TextKey.Month,
};
